/**************************************************************************************************/
/*   File: /src/app/stores/effects/details/effects.ts                                             */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday March 8th 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Observable, of, EMPTY } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import * as fromShared from '../../../shared';
import * as fromActions from '../../actions';
import * as fromStates from '../../states';

/**
 * The router effect
 */
@Injectable()
export class DetailsEffects {

  /**
   * Check dossier status effect
   */
  @Effect()
  checkDossierStatusEffect$ = this.actions$.pipe(
    ofType<fromActions.fromDetails.CheckDossierStatus>(
      fromActions.fromDetails.DossierDetailsActionsType.CHECK_DOSSIER_STATUS
    ),
    switchMap((action: fromActions.fromDetails.CheckDossierStatus) =>
      this.dossierService.checkstatus(action.payload.dossierId).pipe(
        map((dossierStatus: fromShared.models.DossierStatus) =>
          new fromActions.fromDetails.CheckDossierStatusSuccess({
            status: dossierStatus,
            dossierId: action.payload.dossierId
          })
        ),
        catchError(() =>
          of(
            new fromActions.fromDetails.CheckDossierStatusFail({
              message: new fromShared.models.Message(
                fromShared.enums.MessageType.ERROR,
                fromShared.enums.Messages.CANNOT_CHECK_DOSSIER_STATUS,
                fromShared.enums.MessagePositionEnum.TOP,
                fromStates.fromDetails.STATE_NAME
              )
            })
          )
        )
      )
    )
  );

  /**
   * Check dossier status effect
   */
  @Effect()
  checkDossierStatusEffectSuccess$ = this.actions$.pipe(
    ofType<fromActions.fromDetails.CheckDossierStatusSuccess>(
      fromActions.fromDetails.DossierDetailsActionsType.CHECK_DOSSIER_STATUS_SUCCESS
    ),
    map((action: fromActions.fromDetails.CheckDossierStatusSuccess) =>
      new fromActions.fromDetails.LoadDossier({
        dossierId: action.payload.dossierId
      })
    )
  );

  /**
   * The load dossier effect
   */
  @Effect()
  loadDossierEffect$ = this.actions$.pipe(
    ofType<fromActions.fromDetails.LoadDossier>(
      fromActions.fromDetails.DossierDetailsActionsType.LOAD_DOSSIER
    ),
    switchMap((action: fromActions.fromDetails.LoadDossier) =>
      this.dossierService.getDossierById(action.payload.dossierId).pipe(
        mergeMap(
          (dossier: fromShared.models.Dossier) => [
            new fromActions.fromDetails.LoadDossierSuccess({
              dossier: dossier
            })
          ]
        )
      )
    )
  );




  /**
   * The load dossier public effect
   */
  @Effect()
  loadDossierPublicEffect$ = this.actions$.pipe(
    ofType<fromActions.fromDetails.LoadDossierPublic>(
      fromActions.fromDetails.DossierDetailsActionsType.LOAD_DOSSIER_PUBLIC
    ),
    switchMap((action: fromActions.fromDetails.LoadDossierPublic) =>
      this.dossierService.getDossierDetailsById(action.payload.dossierId).pipe(
        mergeMap(
          (dossier: fromShared.models.Dossier) => [
            new fromActions.fromDetails.LoadDossierSuccess({
              dossier: dossier
            })
          ]
        ),
        catchError((error) => {
          console.log('error-->',error.message)
          return of(new fromActions.fromDetails.LoadDossierFail({
              message: new fromShared.models.Message(
                  fromShared.enums.MessageType.ERROR,
                  fromShared.enums.Messages.CANNOT_LOAD_DOSSIER,
                  fromShared.enums.MessagePositionEnum.TOP,
                  fromStates.fromUi.STATE_NAME
              )
          }))
        
        }
        )
      ),
     
      )
  );
  /**
   * The contructor
   * @param store The store
   * @param actions$ The actions
   * @param router The router
   * @param location The location
   */
  constructor(
    private actions$: Actions,
    private dossierService: fromShared.services.DossierService,
    private fileService: fromShared.services.FileService
  ) { }

}
